{
  "#CLAIM_REPORT": {
    "TITLE": "Schadensmeldung",
    "MAIN_PAGE_TITLE": "Schadensmeldungs – Hauptseite",
    "CHANGE": "Ändern",
    "CUSTOMERS": {
      "TITLE": "Kunden",
      "SEARCH_PLACEHOLDER": "Kundenname, Kundennummer oder Belegnummer",
      "SCAN_CONTRACT_BARCODE": "Mietvertrag Barcode scannen",
      "SCAN_CUSTOMER_CARD": "Kundenkarte scannen",
      "OR": "Oder"
    },
    "DOCUMENTS": {
      "TITLE": "Mietverträge",
      "SELECTED_CUSTOMER_LABEL": "Kunde"
    },
    "DEVICES": {
      "TITLE": "Geräte",
      "SELECTED_DOCUMENT_LABEL": "Mietvertrag",
      "CONTEXT_LABEL": "Gerät"
    },
    "DETAIL_EMPTY": {
      "TITLE": "Kein Kunde ausgewählt",
      "DESCRIPTION": "Wählen Sie links einen Kunden aus, oder suchen Sie direkt nach Kundenname, Kundennummer oder Vertragsnummer."
    },
    "COMPLAINT_FORM": {
      "STEP_ERFASSUNG": "Erfassung",
      "STEP_ABSCHLUSS": "Abschluss",
      "STEP_SIGNATURE": "Unterschrift",
      "STEP_THIRD_PARTY": "Drittbeteiligung",
      "STEP_VEHICLES": "Fahrzeuge",
      "STEP_PHOTOS": "Fotos",
      "STEP_DAMAGE": "Schaden",
      "STEP_VALUE": "Schadenshöhe",
      "BASICS_TITLE": "Schadenshergang",
      "BASICS_DESCRIPTION": "Bitte machen Sie Angaben zum Zeitpunkt und Ort des Geschehens.",
      "SUBJECT": "Betreff",
      "DATE": "Datum",
      "DAMAGE_LOCATION": "Schadensort",
      "INCIDENT_DESCRIPTION": "Beschreibung des Vorfalls",
      "THIRD_PARTY_INVOLVED": "Waren Dritte oder andere Fahrzeuge involviert?",
      "ACCIDENT_OPPONENTS_TITLE": "Daten Unfallgegner",
      "ACCIDENT_OPPONENT_LABEL": "Unfallgegner",
      "OPPONENT_TYPE_GENERAL": "Allgemein",
      "OPPONENT_TYPE_VEHICLE": "Fahrzeug",
      "OPPONENT_NAME": "Name",
      "OPPONENT_STREET": "Straße",
      "OPPONENT_HOUSE_NUMBER": "Hausnummer",
      "OPPONENT_ZIP_CODE": "PLZ",
      "OPPONENT_CITY": "Ort",
      "OPPONENT_PHONE": "Telefon",
      "OPPONENT_EMAIL": "E-Mail (optional)",
      "OPPONENT_EMAIL_INVALID": "Ungültige E-Mail-Adresse",
      "OPPONENT_INSURANCE": "Versicherung",
      "OPPONENT_INSURANCE_NUMBER": "Versicherungsnummer",
      "OPPONENT_LICENSE_PLATE": "KFZ Nr. Fahrzeug",
      "OPPONENT_TRAILER_LICENSE_PLATE": "KFZ Nr. Anhänger (optional)",
      "LICENSE_PLATE_INVALID": "Ungültiges Kennzeichen",
      "OWN_VEHICLE_TITLE": "Eigenes Fahrzeug",
      "OWN_VEHICLE_DESCRIPTION": "Bitte machen Sie Angaben zu Ihrem Fahrzeug.",
      "OWN_VEHICLE_LICENSE_PLATE": "KFZ Nr. eigenes Fahrzeug",
      "OWN_TRAILER_LICENSE_PLATE": "KFZ Nr. eigener Anhänger (optional)",
      "OWN_VEHICLE_INSURANCE": "Versicherung",
      "OWN_VEHICLE_INSURANCE_NUMBER": "Versicherungsnummer",
      "ADD_ACCIDENT_OPPONENT": "Weiteren Unfallgegner erfassen",
      "REMOVE_ACCIDENT_OPPONENT": "Unfallgegner entfernen",
      "POLICE_REPORT_TAKEN": "Wurde der Unfall polizeilich aufgenommen?",
      "POLICE_STATION": "Polizeidienststelle",
      "POLICE_CASE_NUMBER": "Aktenzeichen",
      "PHOTOS_TITLE": "Festgestellte Schäden und Foto Dokumentation",
      "PHOTOS_DESCRIPTION": "Bitte beschreiben Sie die beobachteten Schäden so detailliert wie möglich. Ihre Angaben helfen uns bei einer schnellen Bearbeitung.\n\nFotografieren Sie bitte auch gegebenen Falls, Zulassungsschein(e) & Führerschein Dritter, Polizei Protokolle etc.",
      "PHOTOS_TIP_TITLE": "Tipp",
      "PHOTOS_TIP_DESCRIPTION": "Achten Sie beim Aufnehmen der Bilder auf Details, wechseln Sie den Blickwinkel. Je Aussagekräftiger die Fotos sind, um so konkreter kann die erste Abschätzung der Schadenshöhe erfolgen.",
      "DETAILED_DAMAGE_DESCRIPTION": "Detaillierte Schadensbeschreibung",
      "DETAILED_DAMAGE_DESCRIPTION_PLACEHOLDER": "Was ist passiert? Wann haben Sie es bemerkt? Welche Teile sind betroffen?",
      "VALUE_TITLE": "Schadendetails",
      "VALUE_DESCRIPTION": "Geben Sie hier Informationen zur Schadenshöhe und Abwicklung an.",
      "ESTIMATED_VALUE": "Geschätzte Schadenshöhe",
      "ESTIMATED_VALUE_PLACEHOLDER": "0,00 €",
      "TOTAL_LOSS": "Voraussichtlicher Totalschaden?",
      "TOTAL_LOSS_YES": "Ja",
      "TOTAL_LOSS_NO": "Nein",
      "TOTAL_LOSS_AWAITING_REPORT": "Gutachten abwarten",
      "DESIRED_HANDLING": "Gewünschte Abwicklung",
      "DESIRED_HANDLING_INSURANCE_MP": "Versicherung MP",
      "DESIRED_HANDLING_INSURANCE_MP_DESCRIPTION": "Direkte Abrechnung über unsere Partnerversicherung",
      "DESIRED_HANDLING_INSURANCE_CUSTOMER": "Versicherung Kunde",
      "DESIRED_HANDLING_INSURANCE_CUSTOMER_DESCRIPTION": "Eigenständige Schadensregulierung",
      "DESIRED_HANDLING_SELF_PAYER": "Selbstzahler",
      "DESIRED_HANDLING_SELF_PAYER_DESCRIPTION": "Begleichung der Reparaturkosten auf eigene Rechnung",
      "CANCEL": "Abbruch",
      "NEXT": "Weiter",
      "SUBMIT": "Meldung abschließen",
      "BACK": "Zurück",
      "SUMMARY_TITLE": "Zusammenfassung",
      "SUMMARY_DESCRIPTION": "Bitte prüfen Sie die erfassten Daten. Über \"Zurück\" können Sie Angaben korrigieren.",
      "CONTEXT_SECTION": "Mietvertrag & Gerät",
      "CUSTOMER": "Kunde",
      "DOCUMENT": "Beleg",
      "DEVICE": "Gerät",
      "SERIAL_NUMBER": "Seriennummer",
      "DAMAGE_SECTION": "Schadensdaten",
      "DETECTED_DAMAGE_SECTION": "Festgestellte Schäden",
      "PHOTOS_COUNT_LABEL": "Fotos",
      "DAMAGE_DETAILS_SECTION": "Schadendetails",
      "SIGNATURES_TITLE": "Unterschriften",
      "SIGNATURES_DESCRIPTION": "Bitte leisten Sie die erforderlichen Unterschriften, um den Bericht abzuschließen.",
      "CASEWORKER_LABEL": "Sachbearbeiter",
      "CUSTOMER_LABEL": "Kunde",
      "CUSTOMER_SIGNER_NAME": "Name des Kunden",
      "SIGN_HERE": "Hier unterschreiben",
      "CLEAR_SIGNATURE": "Feld leeren",
      "UNDO_SIGNATURE": "Rückgängig",
      "CONFIRMATION": "Ich bestätige die Richtigkeit der oben gemachten Angaben und habe die AGB zur Kenntnis genommen.",
      "SEND_SECTION_TITLE": "Versand",
      "SEND_SECTION_DESCRIPTION": "An wen soll die Schadensmeldung gesendet werden?",
      "EMAIL_PLACEHOLDER": "name@firma.at",
      "ADD_EMAIL": "Mailadresse hinzufügen",
      "REMOVE_EMAIL": "E-Mail-Adresse entfernen",
      "EMAIL_INVALID": "Ungültige E-Mail-Adresse",
      "MAIL_SUBJECT": "Ihre Schadensmeldung",
      "MAIL_BODY": "Im Anhang finden Sie die Schadensmeldung als PDF.",
      "SUCCESS_TITLE": "Schadensmeldung",
      "SUCCESS_SUBTITLE": "Schadensmeldung erfolgreich abgesendet.",
      "NEW_REPORT": "Neue Meldung",
      "DOWNLOAD_PDF": "PDF herunterladen",
      "PDF_ERROR_TITLE": "PDF konnte nicht erstellt werden",
      "PDF_ERROR_DESCRIPTION": "Beim Erstellen des PDF-Dokuments ist ein Fehler aufgetreten.",
      "PDF_ERROR_RETRY": "Erneut versuchen"
    }
  }
}
